import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycarrentalswithdriversinhyderabad() {



  const cardData =
  {
    keyword: 'Luxury Car Rentals with Drivers in Hyderabad',
    heading: 'Aaryan Travels: Luxury Car Rentals with Drivers in Hyderabad',
    headingDescription: 'Aaryan Travels offers premium Luxury Car Rentals with Drivers in Hyderabad for business executives, VIP guests, weddings, and leisure travelers seeking sophistication and comfort. Whether you need a high-end sedan for an airport pickup from Rajiv Gandhi International Airport, a luxury SUV for corporate travel to HITEC City, or a chauffeur-driven car for a special occasion in Banjara Hills or Jubilee Hills, our fleet—including Mercedes, BMW, and Innova Crysta—ensures an elegant ride. With uniformed drivers, plush interiors, and on-request amenities like Wi-Fi and bottled water, Aaryan Travels delivers a first-class travel experience across Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Aaryan Travels',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar, built in 1591 by Sultan Muhammad Quli Qutb Shah, is the most iconic landmark of Hyderabad. Its four grand minarets and Indo-Islamic architecture draw tourists from around the world. The surrounding Laad Bazaar is famous for bangles and pearls. Illuminated beautifully at night, it becomes a breathtaking sight. Charminar is Hyderabad’s eternal symbol of history and culture."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic fortress known for its legendary acoustics, royal halls, and historic diamond trade. It was once home to the famous Kohinoor and Hope diamonds. The climb to the top offers panoramic views of Hyderabad. The evening sound and light show narrates tales of valor and royalty. Golconda Fort is Hyderabad’s glorious testimony to its royal past."
  },
  {
    "title": "Ramoji Film City",
    "description": "Spread across 2,000 acres, Ramoji Film City is the world’s largest film studio complex. It features grand movie sets, amusement parks, live shows, and adventure activities. Visitors can explore themed attractions like Bahubali sets and royal palaces. It is a dreamland for cinema lovers and families. Ramoji Film City is Hyderabad’s world of entertainment and fantasy."
  },
  {
    "title": "Hussain Sagar Lake & Buddha Statue",
    "description": "Hussain Sagar Lake, built in 1563, is a heart-shaped lake connecting Hyderabad and Secunderabad. At its center stands a towering monolithic Buddha statue accessible by ferry rides. The necklace road surrounding the lake comes alive in the evenings. The calm waters and glittering skyline create a charming view. Hussain Sagar is Hyderabad’s scenic spot for leisure and serenity."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a stunning white marble temple dedicated to Lord Venkateswara, located atop a hill. The panoramic view of the city and Hussain Sagar Lake from the temple is captivating. The peaceful atmosphere and elegant carvings make it a preferred place for meditation. Birla Mandir is Hyderabad’s shining beacon of devotion."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest art museums, showcasing over 40,000 artifacts collected by Nawab Mir Yousuf Ali Khan. The collection includes sculptures, paintings, clocks, weapons, and the famous Veiled Rebecca statue. Each gallery offers a glimpse into global culture and history. Salar Jung Museum is Hyderabad’s treasure house of art and antiquity."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace served as the official residence of the Nizams of Hyderabad. Its grand courtyards, crystal chandeliers, and vintage car collection reflect royal opulence. Visitors can walk through beautifully preserved halls and gardens. Cultural events are often hosted within the palace grounds. Chowmahalla Palace is Hyderabad’s regal masterpiece of elegance."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Nehru Zoological Park is one of India’s most well-maintained zoos, home to tigers, lions, elephants, and exotic birds. Safari rides, toy trains, and reptile houses offer entertainment for families. The lush greenery enhances the overall experience. It is a favorite spot for wildlife lovers and children. Nehru Zoo is Hyderabad’s exciting retreat into nature."
  },
  {
    "title": "Laad Bazaar",
    "description": "Located near Charminar, Laad Bazaar is famous for its colorful lacquer bangles, pearls, and bridal accessories. The narrow lanes filled with vibrant stalls offer a rich shopping experience. Bargain seekers love exploring its traditional crafts. The lively atmosphere keeps it bustling day and night. Laad Bazaar is Hyderabad’s buzzing marketplace of culture and color."
  },
  {
    "title": "Jalavihar Water Park",
    "description": "Jalavihar is a popular water park located on Necklace Road, offering thrilling slides, wave pools, and splash rides. It is ideal for families and youngsters seeking a fun-filled day. The nearby lakeside view adds charm to the adventure. Food courts and play areas make it even more enjoyable. Jalavihar is Hyderabad’s splash of joy and excitement."
  }
],



"services": [
  {
    "name": "Luxury Car Rentals with Drivers in Hyderabad",
    "description": "Luxury Car Rentals with Drivers in Hyderabad provide an exquisite fleet of high-end vehicles paired with professional chauffeurs, offering clients the ultimate in comfort, style, and convenience. Whether for corporate travel, special events, or leisurely rides, these services ensure punctuality, safety, and a premium experience throughout the journey."
  },
  {
    "name": "Chauffeur Driven Luxury Cars Hyderabad",
    "description": "Chauffeur Driven Luxury Cars Hyderabad specializes in delivering sophisticated rides with expertly trained drivers who prioritize customer comfort and discretion. This service caters to executives, VIPs, and individuals seeking first-class transportation with a focus on seamless travel and impeccable service."
  },
  {
    "name": "Executive Car Hire Hyderabad",
    "description": "Executive Car Hire Hyderabad offers stylish and reliable luxury vehicles for business professionals and corporate clients. The service emphasizes privacy, professionalism, and efficiency, making it ideal for meetings, airport transfers, and other executive travel needs."
  },
  {
    "name": "Premium Car with Driver Hyderabad",
    "description": "Premium Car with Driver Hyderabad combines top-tier automobiles with experienced chauffeurs to provide an elevated travel experience. Suitable for business trips, social events, and luxury travel, this service guarantees comfort, elegance, and punctuality."
  },
  {
    "name": "Corporate Luxury Rentals Hyderabad",
    "description": "Corporate Luxury Rentals Hyderabad caters to companies seeking dependable and high-class vehicle rentals for their executives and clients. The service offers flexible plans, well-maintained fleets, and professional chauffeurs to ensure smooth business transportation."
  },
  {
    "name": "Wedding Luxury Car Hyderabad",
    "description": "Wedding Luxury Car Hyderabad offers premium vehicles for weddings and related celebrations, complete with chauffeurs trained to handle wedding day logistics gracefully. This service ensures a grand and stylish arrival for the bride, groom, and guests."
  },
  {
    "name": "Best Luxury Cab Hyderabad",
    "description": "Best Luxury Cab Hyderabad is renowned for its exceptional fleet of luxury vehicles and top-notch chauffeur services. Clients enjoy reliable, elegant, and safe rides that cater to a variety of personal and professional needs."
  },
  {
    "name": "Affordable Luxury Car Hire Hyderabad",
    "description": "Affordable Luxury Car Hire Hyderabad provides access to premium cars and professional drivers at competitive rates. Perfect for clients who want luxury without a hefty price tag, the service maintains high standards of quality and customer satisfaction."
  },
  {
    "name": "Online Luxury Booking Hyderabad",
    "description": "Online Luxury Booking Hyderabad offers a user-friendly digital platform for booking luxury cars with drivers. This service provides instant confirmation, easy scheduling, and real-time tracking to streamline premium transportation arrangements."
  },
  {
    "name": "Sedan & SUV Luxury Rentals Hyderabad",
    "description": "Sedan & SUV Luxury Rentals Hyderabad feature a versatile selection of stylish sedans and spacious SUVs, suitable for corporate travel, family outings, and special occasions. Each vehicle comes with a professional chauffeur to ensure comfort and safety."
  },
  {
    "name": "Elite Car Hire Hyderabad",
    "description": "Elite Car Hire Hyderabad delivers exclusive luxury vehicles and impeccable chauffeur services tailored for discerning clients. The service promises sophistication, privacy, and a superior travel experience for all occasions."
  },
  {
    "name": "Hyderabad Prestige Cars",
    "description": "Hyderabad Prestige Cars offers a premium fleet of prestigious automobiles, including luxury sedans and SUVs, for clients who demand excellence in vehicle quality and driver professionalism. Perfect for high-profile business and personal use."
  },
  {
    "name": "Luxury Event Transport Hyderabad",
    "description": "Luxury Event Transport Hyderabad specializes in providing elegant transportation solutions for large-scale events, weddings, and corporate gatherings. The service includes fleet management and chauffeur coordination to ensure flawless transport logistics."
  },
  {
    "name": "Chauffeur Luxury Services Hyderabad",
    "description": "Chauffeur Luxury Services Hyderabad features highly trained professional drivers who deliver discreet, courteous, and safe transportation in luxury vehicles. This service is ideal for VIPs, executives, and clients requiring personalized travel."
  },
  {
    "name": "High-End Car Rentals Hyderabad",
    "description": "High-End Car Rentals Hyderabad provides access to an impressive collection of luxury vehicles equipped with expert chauffeurs. Whether for business, leisure, or special occasions, the service guarantees comfort, style, and reliability."
  }
],
"tableData": [
  ["Luxury Car Rentals with Drivers in Hyderabad", "Chauffeur Driven Luxury Cars Hyderabad"],
  ["Executive Car Hire Hyderabad", "Premium Car with Driver Hyderabad"],
  ["Corporate Luxury Rentals Hyderabad", "Wedding Luxury Car Hyderabad"],
  ["Best Luxury Cab Hyderabad", "Affordable Luxury Car Hire Hyderabad"],
  ["Online Luxury Booking Hyderabad", "Sedan & SUV Luxury Rentals Hyderabad"],
  ["Elite Car Hire Hyderabad", "Hyderabad Prestige Cars"],
  ["Luxury Event Transport Hyderabad", "Chauffeur Luxury Services Hyderabad"],
  ["High-End Car Rentals Hyderabad", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Luxury Car Rentals with Drivers in Hyderabad",
    "WhyChoosedescription": "Aaryan Travels offers premium luxury car rentals with professional drivers in Hyderabad, perfect for business and leisure travel."
  },
  {
    "WhyChooseheading": "Wide Range of Luxury Vehicles",
    "WhyChoosedescription": "Choose from a fleet of well-maintained luxury cars, including sedans and SUVs, tailored to your comfort and style."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Chauffeurs",
    "WhyChoosedescription": "Our professional drivers ensure punctual, safe, and discreet service to enhance your travel experience."
  },
  {
    "WhyChooseheading": "Sanitized and Comfortable Vehicles",
    "WhyChoosedescription": "All cars are regularly cleaned and maintained for hygiene and passenger comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy all-inclusive rates covering fuel, tolls, and driver allowances with no surprise fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Customize your luxury car rental with driver based on hourly, daily, or long-term rental options."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service Across Hyderabad",
    "WhyChoosedescription": "We guarantee timely pickups and drop-offs anywhere in Hyderabad for a seamless luxury travel experience."
  }
]

















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury car rentals with drivers in Hyderabad?',
    answer: 'Yes, Aaryan Travels provides premium luxury car rentals with professional drivers in Hyderabad for a comfortable and stylish ride.',
  },
  {
    question: 'How can I book luxury car rentals with drivers in Hyderabad?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Hyderabad.',
  },
  {
    question: 'What types of luxury cars are available for rental with drivers in Hyderabad?',
    answer: 'Aaryan Travels offers a range of luxury vehicles including Mercedes-Benz, BMW, Audi, and other premium cars with drivers in Hyderabad.',
  },
  {
    question: 'Are the drivers experienced and trained for luxury car rentals in Hyderabad?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and committed to providing a premium luxury experience.',
  },
  {
    question: 'Can luxury car rentals with drivers be booked for corporate and personal use in Hyderabad?',
    answer: 'Yes, these rentals are perfect for corporate travel, airport transfers, weddings, and special occasions in Hyderabad.',
  },
  {
    question: 'Is the luxury car rental service with drivers available 24x7 in Hyderabad?',
    answer: 'Yes, Aaryan Travels offers round-the-clock luxury car rental services with drivers to suit your schedule in Hyderabad.',
  },
  {
    question: 'Are hygiene and safety protocols followed for luxury car rentals?',
    answer: 'All vehicles are sanitized thoroughly, and drivers adhere to strict safety and hygiene standards for your comfort and safety.',
  },
  {
    question: 'What payment options are accepted for luxury car rentals with drivers in Hyderabad?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the luxury car rental period in Hyderabad?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Reddy',
    feedback: 'Aaryan Travels provided an exceptional luxury car rental experience with drivers in Hyderabad. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Sharma',
    feedback: 'Professional service and excellent luxury cars with drivers from Aaryan Travels in Hyderabad. Made my trip very comfortable.',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const luxuryCarRentalsHyderabadSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Luxury Car Rentals with Drivers in Hyderabad",
  "description": "Aaryan Travels offers chauffeur-driven luxury car rentals in Hyderabad, including executive car hire, premium cars with drivers, corporate luxury rentals, wedding luxury cars, and more.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Hyderabad"
  },
  "serviceType": "Luxury Car Rental Service",
  "keywords": "Luxury Car Rentals with Drivers in Hyderabad, Chauffeur Driven Luxury Cars Hyderabad, Executive Car Hire Hyderabad, Premium Car with Driver Hyderabad, Corporate Luxury Rentals Hyderabad, Wedding Luxury Car Hyderabad, Best Luxury Cab Hyderabad, Affordable Luxury Car Hire Hyderabad, Online Luxury Booking Hyderabad, Sedan & SUV Luxury Rentals Hyderabad, Elite Car Hire Hyderabad, Hyderabad Prestige Cars, Luxury Event Transport Hyderabad, Chauffeur Luxury Services Hyderabad, High-End Car Rentals Hyderabad"
};






  return (
    <div>
<Helmet>
  <title>Luxury Car Rentals with Drivers in Hyderabad | Chauffeur Driven Executive Cars | Aaryan Travels</title>
  <meta
    name="description"
    content="Book luxury car rentals with drivers in Hyderabad at Aaryan Travels. Chauffeur-driven executive cars, premium vehicles, corporate and wedding luxury rentals."
  />
  <meta
    name="keywords"
    content="Luxury Car Rentals with Drivers in Hyderabad, Chauffeur Driven Luxury Cars Hyderabad, Executive Car Hire Hyderabad, Premium Car with Driver Hyderabad, Corporate Luxury Rentals Hyderabad, Wedding Luxury Car Hyderabad, Best Luxury Cab Hyderabad, Affordable Luxury Car Hire Hyderabad, Online Luxury Booking Hyderabad, Sedan & SUV Luxury Rentals Hyderabad, Elite Car Hire Hyderabad, Hyderabad Prestige Cars, Luxury Event Transport Hyderabad, Chauffeur Luxury Services Hyderabad, High-End Car Rentals Hyderabad"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryCarRentalsHyderabadSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/93.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurycarrentalswithdriversinhyderabad;